import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import RedirectingIcon from 'src/images/icons/receiving-redirecting.svg?react';
import { useGetCartQuery } from 'src/hooks';
import { getCartIdAtom } from 'src/store';
import { VendorListAndPriceDisc, VendorLogoBlock } from 'src/components';
import { ReceiveChugAnimation } from './ReceiveChugAnimation';
// import { ReactComponent as SpinnerIcon } from 'src/images/icons/spinner.svg';

export const ReceiveHeader = () => {
  const cartId = useAtomValue(getCartIdAtom);

  const cartQuery = useGetCartQuery({ cartId });

  const { t } = useTranslation();

  return (
    <section className='mx-auto flex w-full max-w-[1240px] flex-col rounded bg-white px-4 py-3 sm:px-8 sm:py-6'>
      <div className='flex flex-row flex-nowrap items-start justify-between gap-8'>
        <div className='flex flex-col items-start justify-start gap-0'>
          <div className='flex items-center justify-start gap-2 whitespace-nowrap text-xs'>
            <RedirectingIcon className='mb-0.5 h-4 w-4' />
            <p className='text-100'>{t('common.cart_id')}</p>
          </div>

          {/* <div className='flex flex-row flex-nowrap items-center'> */}
          <p className='z-10 text-center font-primary text-[50px] font-normal leading-[50px] tracking-[5px] text-primary-dark xs:text-[54px] xs:leading-[54px]'>
            {cartId}
          </p>
          {/* TODO: should this be added back in? Seems weird to have 2 animations running on the screen at the same time */}
          {/* {!tooLong && !hasMissing && (
            <SpinnerIcon className='spinner h-8 w-8 animate-spin fill-transparent stroke-emerald-500 stroke-[4px]' />
          )} */}
          {/* </div> */}
        </div>

        <div className='flex w-fit flex-col flex-nowrap items-end justify-end gap-1 sm:flex-row sm:items-center sm:justify-end'>
          <VendorLogoBlock
            vendor={cartQuery.data?.vendor || ''}
            size='medium'
          />
          <div className='hidden xs:block'>
            <VendorListAndPriceDisc
              timestamp={cartQuery.data?.timestamp || 0}
              itemCount={cartQuery.data?.items?.length ?? 0}
              cartVendor={cartQuery.data?.vendor || ''}
              vendorDisplayName={cartQuery.data?.vendorDisplayName || ''}
              // cartStore={cartQuery.data?.store || ''} // do we want to show the store here?
              showPriceDateDisclaimer={false}
              darkText={true}
              includeMarginRight={false}
            />
          </div>
        </div>
      </div>

      <ReceiveChugAnimation
        store={cartQuery.data?.store || ''}
        itemsCount={cartQuery.data?.items?.length ?? 0}
      />
    </section>
  );
};
